import React, { useState } from 'react';

const styles = {
  container: {
    width: '100%',
    backgroundColor: '#ff000024',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    padding: '10px 44px'
  },
  text: {
    maxWidth: '980px',
    color: '#FFFFFF',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0.1px',
    textAlign: 'center'
  },
  link: {
    color: '#FFFFFF',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '18px',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    whiteSpace: 'nowrap'
  },
  closeBtn: {
    position: 'absolute',
    right: '14px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    color: '#FFFFFF',
    opacity: 0.85,
    fontSize: '16px',
    fontWeight: 300,
    lineHeight: 1,
    cursor: 'pointer',
    padding: '4px'
  }
};

export default function GeoRestrictionBanner() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div style={styles.container}>
      <span style={styles.text}>
        You may be accessing our products and services from a restricted
        jurisdiction. We do not allow access from certain jurisdictions
        including locations subject to sanctions restrictions and other
        jurisdictions where our services are ineligible for use. For more
        information, see our{' '}
        <a
          href="https://www.hootdex.com/tos/"
          target="_blank"
          rel="noreferrer"
          style={styles.link}
        >
          Terms of Use
        </a>
        .
      </span>
      <button
        type="button"
        aria-label="Close"
        onClick={() => setVisible(false)}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.85')}
        style={styles.closeBtn}
      >
        &#215;
      </button>
    </div>
  );
}
